import React from "react";

const Nav = () => {
  return (
    <nav style={{ backgroundColor: "#333", color: "white", padding: "1rem", position: "fixed", top: 0, width: "100%", zIndex: 1000 }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h1 style={{ margin: 0 }}>10 Roosevelt Rd</h1>
        <ul style={{ listStyle: "none", display: "flex", gap: "2rem", margin: 0, padding: 0 }}>
          <li><a href="#about" style={{ color: "white", textDecoration: "none" }}>About</a></li>
          <li><a href="#gallery" style={{ color: "white", textDecoration: "none" }}>Images</a></li>
          <li><a href="#videos" style={{ color: "white", textDecoration: "none" }}>Videos</a></li>
          <li><a href="#floorplans" style={{ color: "white", textDecoration: "none" }}>Floor Plans</a></li>
          <li><a href="#tour" style={{ color: "white", textDecoration: "none" }}>3D Tour</a></li>
          <li><a href="#files" style={{ color: "white", textDecoration: "none" }}>Files</a></li>
          <li><a href="#map" style={{ color: "white", textDecoration: "none" }}>Map</a></li>
          <li><a href="#contact" style={{ color: "white", textDecoration: "none" }}>Contact</a></li>
        </ul>
      </div>
    </nav>
  );
};

export default Nav;